import React from 'react'
import Navbar from '../../components/navbar_poc'
import { Link } from 'react-router-dom'
import bg1 from '../../assets/images/single_case.jpg'
import client from '../../assets/images/client/05.jpg'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'
import SEO from '../../components/seo'
export default function PageAILabs() {
  return (
    <>
    <Navbar navLight={true}/> 
    <SEO
  title="AI Labs at Pioneer One Global – Automate, Optimize, and Scale"
  description="From intelligent compliance to AI-driven operations, Pioneer One Global’s AI Labs help you harness automation for smarter growth in India and beyond."
  url="https://www.pioneeroneglobal.com/ai-labs"
  image="https://www.pioneeroneglobal.com/images/og-ai-labs.jpg"
/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row position-relative align-items-center pt-4">
              <div className="col-lg-6">
                  <div className="title-heading p-4 rounded bg-white shadow mt-4">
                      <span className="badge bg-primary rounded-pill">AI</span>
                      <h2 className="mt-3">AI Lab</h2>
                      <p className="para-desc text-muted">Coming soon</p>
                      <div className="mt-4">
                          <div className="d-flex">
                              {/* <img src={client} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/> */}
                              <div className="author mt-3">
                                  <h5 className="mb-0"><Link to="#" className="text-dark name">Siva Bala Narayanan</Link></h5>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="casestudy">
                       <p className="text-muted description">At Pioneer One Global, we believe the future of India-entry services lies at the intersection of people, process, and intelligent automation.</p>

                      <p className="text-muted description">AI Labs is our sandbox — a space where we prototype, test, and refine AI-powered tools designed to make doing business in India faster, smarter, and more scalable..</p>
                      
                      <h4 className="mt-4">What We’re Building:</h4>
                      <p className="text-muted description">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters.</p>
                      <h5><i className="mdi mdi-star"></i> India Entry Readiness Bot</h5>
                      <p className="text-muted">A GPT-powered assistant that generates customized checklists based on a client’s country, business type, and goals.</p>
                      <h5><i className="mdi mdi-star"></i> Intercompany Invoice Assistant</h5>
                      <p className="text-muted">Converts natural language activity logs into structured, GST-compliant invoices.</p>
                      <h5><i className="mdi mdi-star"></i> Onboarding Workflow Agent</h5>
                      <p className="text-muted">Helps collect and organize client inputs and KYC data with human-in-the-loop checkpoints.</p>
                      <h5><i className="mdi mdi-star"></i>Compliance Q&A Assistant</h5>
                      <p className="text-muted">Uses RAG to give consistent, verifiable answers to common India compliance questions.</p>
                     <h5><i className="mdi mdi-star"></i> Voice-enabled onboarding assistant</h5>
                      <p className="text-muted">streamlines onboarding by guiding users through setup, compliance, and documentation—hands-free.</p>
                      <h5><i className="mdi mdi-star"></i> Auto-generated incorporation timeline planner</h5>
                      <p className="text-muted">An AI-powered tool that automatically creates a customized timeline for incorporating and launching your business in India.</p>
                      <h5><i className="mdi mdi-star"></i> Cross-border document scanner and classifier</h5>
                      <p className="text-muted">An AI-driven tool that scans, classifies, and organizes cross-border business documents for faster onboarding and compliance.</p>
                 
 
                      <h4 className="mt-4">Work With Us</h4>
                      <p className="text-muted description">We're currently collaborating with a small group of clients in private beta. If you're interested in being part of that journey, let us know.</p>

                      <p className="text-muted description">In the meantime, follow our progress or drop us a note — we’d love to hear what you'd like to see from the future of India-entry AI.</p>
                    </div>
              </div>
          </div>
      </div>
          <div className="container mt-100 mt-60">
                <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
                    <div className="row align-items-center">
                        <div className="col-sm-7">
                            <div className="text-sm-start">
                                <h4>Want to partner with our AI Lab or pilot a solution?</h4>
                             </div>
                        </div>
      
                        <div className="col-sm-5 mt-4 mt-sm-0">
                            <div className="text-sm-end">
                                <Link to="/contact" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Let's talk!</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
